<template>
  <div>
    <p-vue-panel :name="'meter' + meter.MeterNum">
      <template #header>
        <div>
          <div class="p-panel-title">
            <div>{{ __("Counter number") }} {{ meter.MeterNum }}</div>
          </div>
          <div class="p-panel-title p-mt-2">
            <div>{{ meter.Number }}</div>
          </div>
        </div>
      </template>
      <div class="p-d-flex">
        <!-- <div class="p-d-flex p-flex-column">
          <span>{{ __("סוג מונה") }}:</span>
          <span class="meter-data">{{ meter.MeterTypeName }}</span>
        </div> -->
        <div class="p-d-flex p-flex-column p-ml-4" v-if="localMeter.MRID">
          <span>{{ __("Last read") }}:</span>
          <span class="meter-data">{{ meter.ReadCount }}</span>
        </div>
        <div class="p-d-flex p-flex-column" v-if="localMeter.MRID">
          <span>{{ __("Last read date") }}:</span>
          <span class="meter-data">{{
            dateFormat(meter.ReadDate, true, false, true)
          }}</span>
        </div>
      </div>
      <div class="p-d-flex p-jc-end p-mt-2" style="gap: 10px;">
        <p-vue-button
          v-if="!localMeter.MRID || localMeter.IsFirstReading"
          icon="pi pi-trash"
          class="p-button-rounded p-button-danger p-button-outlined"
          @click="confirmDelete"
        />
        <p-vue-button
          :label="'+ ' + __('Enter meter reading')"
          class="p-button-rounded p-button-info p-button-outlined"
          @click="
            $router.push({
              name: 'ConsumptionReport',
              params: {
                meterid: meter.MeterID,
                bid: BID,
              },
            })
          "
        />
        <p-vue-button
          icon="pi pi-list"
          class="p-button-rounded p-button-success p-button-outlined"
          @click="
            $router.push({
              name: 'ReadingList',
              params: {
                meterid: meter.MeterID,
                bid: BID,
              },
            })
          "
        />
        <p-vue-button
          icon="pi pi-pencil"
          class="p-button-rounded p-button-success p-button-outlined"
          @click="editMeter"
        />
      </div>
    </p-vue-panel>
    <i-override-dialog
      v-model:visible="showEditModel"
      :style="{
        width: '100%',
        maxWidth: 'calc(100vw - 10px)',
      }"
      :modal="true"
      :dismissableMask="true"
      :title="__('Counter editing')"
    >
      <local-edit-electricity-meter
        :meter="localMeter"
        :close="() => (showEditModel = false)"
        :isEdit="true"
        @refreshAllMeters="$emit('refreshAllMeters')"
      ></local-edit-electricity-meter>
    </i-override-dialog>
  </div>
  <p-vue-confirm-popup></p-vue-confirm-popup>
</template>

<script>
import {
  dateFormat,
  errorReceived,
  showSuccessOrFailedModal,
} from "@/services/apointUtil";
import { callProc, apiParam, apiPType } from "@/services/APointAPI";
import LocalEditElectricityMeter from "./add-electricity-meter";
import { __ } from "@/plugins/i18n/";
export default {
  components: {
    LocalEditElectricityMeter,
  },
  props: {
    BID: null,
    meter: {},
    commision: {},
  },
  emits: ["refreshAllMeters"],
  data() {
    return {
      dateFormat,
      localMeter: {},
      showEditModel: false,
    };
  },
  mounted() {
    this.localMeter = this.meter;
    // console.log(this.localMeter);
  },
  methods: {
    editMeter() {
      this.showEditModel = true;
    },
    confirmDelete(event) {
      this.$confirm.require({
        target: event.currentTarget,
        message: __("Are you sure you want to delete this meter?"),
        icon: "pi pi-exclamation-triangle",
        accept: () => {
          this.deleteMeter();
        },
        reject: () => {},
      });
    },
    deleteMeter() {
      this.$store.dispatch("doLoading", true);
      let procParams = [
        apiParam("MeterID", this.localMeter.MeterID, apiPType.Int),
      ];
      callProc("WorkerApp_DeleteMeter", procParams)
        .then((result) => {
          result = JSON.parse(result);
          if (result.procReturnValue == 0) {
            showSuccessOrFailedModal(__("The meter was deleted successfully"));
            this.$emit("refreshAllMeters");
          } else {
            showSuccessOrFailedModal(
              __("An error occurred while deleting the counter"),
              false
            );
          }
          this.$store.dispatch("doLoading", false);
        })
        .catch(() => {
          errorReceived("WorkerApp_DeleteMeter");
        });
    },
  },
};
</script>

<style scoped>
.meter-data {
  color: var(--color-accent);
}
</style>
